import { render, staticRenderFns } from "./PropertyFilterItem.vue?vue&type=template&id=59d74062&scoped=true&"
import script from "./PropertyFilterItem.vue?vue&type=script&lang=js&"
export * from "./PropertyFilterItem.vue?vue&type=script&lang=js&"
import style0 from "./PropertyFilterItem.vue?vue&type=style&index=0&id=59d74062&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d74062",
  null
  
)

export default component.exports